<!--
  메인 비주얼 슬라이드 컴포넌트
-->
<template>
  <div id="mmpVisualSlide2" class="wrap_visual_slide2">
    <div class="inner">

      <!-- swiper UI -->
      <div ref="mmpVisualSlide" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in slideData"
            :key="index"
            :class="['swiper-slide', {light_bg : $utils.isLightColor(item.color)}]"
            :style="[{backgroundColor: `${item.color}`}]"
          >
            <a
              href="javascript:void(0)"
              class="slide_link"
            >
              <div class="thumb">
                <img :src="isDesktop ? item.imgPc : item.imgMo">
              </div>
              <div class="wrap_slide_txt">
                <span class="slide_title" v-html="item.bannNm"/>
                <span class="slide_msg" v-html="item.scrptCntnt"/>
              </div>
            </a>
          </div>
        </div>

        <!-- swiper control ui -->
        <div ref="swiperControl" class="wrap_swiper_control">

          <div class="inner">

            <!-- fraction -->
            <div class="swiper_fraction">
              <span class="txt current">{{ swiper.activeIndex }}</span>
              <span>/</span>
              <span class="txt total">{{ slideData.length }}</span>
            </div>
            <!-- // fraction -->

            <!-- pagination -->
            <div
              v-show="isDesktop"
              class="swiper_pagination" />
            <!-- // pagination -->

            <div class="wrap_swiper_button">

              <!-- play, pause -->
              <button
                ref="swiperPlayBtn"
                class="btn_swiper_play"
                type="button"
                @click.stop="controlAutoplay()"
              >자동실행 제어</button>
              <!-- // play, pause -->

              <!-- navigation -->
              <div
                v-show="isDesktop"
                class="swiper_navigation"
              >
                <div class="swiper-button-prev" />
                <div class="swiper-button-next" />
              </div>
              <!-- // navigation -->

            </div>

          </div>

        </div>
        <!-- // swiper control ui -->
      </div>
      <!-- // swiepr UI -->
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'CompMmpVisualSlide2',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    potltInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      swiper: {
        instance: null,
        activeIndex: 1,
        option: {
          speed: 800,
          loop: true,
          responsive: true,
          pagination: {
            el: '#mmpVisualSlide2 .swiper_pagination',
            clickable: true
          },
          navigation: {
            prevEl: '#mmpVisualSlide2 .swiper-button-prev',
            nextEl: '#mmpVisualSlide2 .swiper-button-next'
          },
          autoplay: {
            delay: 8000,
            disableOnInteraction: false
          },
          on: {
            init: () => {
              this.setActiveIndex()
              this.setControlColor()
            },
            slideChange: () => {
              this.setActiveIndex()
              this.setControlColor()
            },
            touchStart: (e) => {
              let isControlBtn = false

              if (e.target.classList.contains('btn_swiper_play') || e.target.classList.contains('swiper-button-prev') || e.target.classList.contains('swiper-button-next')) {
                isControlBtn = true
              }

              if (!isControlBtn) this.setAutoplay(false)
            },
            slideChangeTransitionEnd: () => {
              this.updateDuplicatedSlide()
            }
          }
        }
      },
      slideData: [] // 슬라이드 데이터
    }
  },
  computed: {
    // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    }
  },
  watch: {
    potltInfo: {
      handler (newVal) {
        this.updateSwiperAutoplayDelay()
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy () {
    this.removeEvt()
  },
  mounted () {
    this.$nextTick(() => {
      this.getSlideData() // 슬라이드 데이터 설정
      this.updateSwiperAutoplayDelay()
      this.initSwiper()
      this.addEvt()
    })
  },
  methods: {
    // 특정 엘리먼트의 부모 클래스가 일치하는지 여부 확인
    checkParent (parentClass, target) {
      let node = target.parentNode
      while (node != null) {
        if (node.classList.contains(parentClass)) {
          return true
        }
        node = node.parentNode
      }
      return false
    },
    addEvt () {
      this.$nextTick(() => {
        const slideWrapper = document.querySelector('#mmpVisualSlide2')
        const swiperBtnWrapper = document.querySelector('#mmpVisualSlide2 .wrap_swiper_control')

        window.addEventListener('click', (e) => {
          const target = e.target

          if (slideWrapper.contains(target) && !swiperBtnWrapper.contains(target)) {
            if (target.classList.contains('slide_link') || this.checkParent('slide_link', target)) {
              this.goSlideLink()
            }
          }
        })
      })
    },
    removeEvt () {
      window.removeEventListener('click', this.addEvt)
    },
    updateSwiperAutoplayDelay () {
      if (this.potltInfo && typeof this.potltInfo.rolinGapTmHms === 'string') {
        const setDelay = Number(this.potltInfo.rolinGapTmHms)

        // 변환된 값이 유효한 숫자인지 확인
        if (!isNaN(setDelay) && setDelay >= 0) {
          // autoplay되는 시간을 mgmt의 모바일웹 메인배너 -> 롤링간격 값이 반영되게 함
          this.swiper.option.autoplay.delay = setDelay * 1000 || this.swiper.option.autoplay.delay
          if (this.swiper.instance) {
            this.updateSwiper()
          }
        }
      }
    },
    // 슬라이드 데이터 수집
    getSlideData () {
      // 퍼블 소스
      /*
        let result
        // NOTE: 데이터 처리

        result = [
          {
            imgPc: '/static/images/@temp/mmp_slide_pc_01.jpg',
            imgMo: '/static/images/@temp/mmp_slide_mo_01.jpg',
            color: '#16b5f6',
            title: '',
            msg: '',
            link: 'javascript:void(0)'
          },
          {
            imgPc: '/static/images/@temp/mmp_slide_pc_02.jpg',
            imgMo: '/static/images/@temp/mmp_slide_mo_02.jpg',
            color: '#edeef0',
            title: '',
            msg: '',
            link: 'javascript:void(0)'
          },
          {
            imgPc: '/static/images/@temp/mmp_slide_pc_01.jpg',
            imgMo: '/static/images/@temp/mmp_slide_mo_01.jpg',
            color: '#16b5f6',
            title: '',
            msg: '',
            link: 'javascript:void(0)'
          },
          {
            imgPc: '/static/images/@temp/mmp_slide_pc_02.jpg',
            imgMo: '/static/images/@temp/mmp_slide_mo_02.jpg',
            color: '#edeef0',
            title: '',
            msg: '',
            link: 'javascript:void(0)'
          },
          {
            imgPc: '/static/images/@temp/mmp_slide_pc_01.jpg',
            imgMo: '/static/images/@temp/mmp_slide_mo_01.jpg',
            color: '#16b5f6',
            title: '',
            msg: '',
            link: 'javascript:void(0)'
          },
          {
            imgPc: '/static/images/@temp/mmp_slide_pc_02.jpg',
            imgMo: '/static/images/@temp/mmp_slide_mo_02.jpg',
            color: '#edeef0',
            title: '',
            msg: '',
            link: 'javascript:void(0)'
          }
        ]

        this.slideData = result // data 저장
      */

      this.slideData = this.potltInfo.potltData.map((item, index) => ({
        imgPc: `/mrm/v1/ignore/attach/image/${item.imgAttchFileId}/${item.imgFileId}`,
        imgMo: `/mrm/v1/ignore/attach/image/${item.mobImgAttchFileId}/${item.mobImgFileId}`,
        color: item.bgColorCd,
        bannUrl: index < this.potltInfo.potltData.length ? this.potltInfo.potltData[index].bannUrl : item.link,
        genLinkScCd: item.genLinkScCd
      }))

      this.initSwiper() // 슬라이드 UI에 데이터 출력
    },
    // 스와이퍼 인스턴스 존재 여부 반환
    hasSwiperInstance () {
      const swiperInstance = this.swiper.instance
      let ret = false

      if (swiperInstance !== null) ret = true
      return ret
    },
    // 스와이퍼 autoplay 실행 여부 반환
    isSwiperAutoPlaying () {
      let ret = false

      if (this.hasSwiperInstance()) {
        const swiperInstance = this.swiper.instance

        if (swiperInstance.autoplay.running === true) ret = true
      }

      return ret
    },
    // 스와이퍼 인스턴스 초기화
    initSwiper () {
      this.$nextTick(() => {
        const swiperContainer = this.$refs.mmpVisualSlide

        if (this.hasSwiperInstance()) {
          this.updateSwiper()
        } else {
          this.swiper.instance = new Swiper(swiperContainer, this.swiper.option)
        }
      })
    },
    // 스와이퍼 인스턴스 업데이트
    updateSwiper () {
      const swiperInstance = this.swiper.instance

      if (this.hasSwiperInstance()) swiperInstance.update()
    },
    // 스와이퍼 인스턴스 제거
    destroySwiper () {
      const swiperInstance = this.swiper.instance

      if (this.hasSwiperInstance()) {
        swiperInstance.destroy()
        this.swiper.instance = null
      }
    },
    // pause, play 버튼 클릭 이벤트
    controlAutoplay () {
      if (this.hasSwiperInstance()) {
        if (this.isSwiperAutoPlaying()) {
          this.setAutoplay(false)
        } else {
          this.setAutoplay(true)
        }
      }
    },
    // autoplay 상태 설정
    setAutoplay (status) {
      const swiperInstance = this.swiper.instance

      if (this.hasSwiperInstance()) {
        if (status) {
          swiperInstance.autoplay.start()
          this.setPlayBtn(true)
        } else {
          swiperInstance.autoplay.stop()
          this.setPlayBtn(false)
        }
      }
    },
    // play, paues 버튼 상태 설정
    setPlayBtn (status) {
      if (status) {
        this.$refs.swiperPlayBtn.classList.remove('paused')
      } else {
        this.$refs.swiperPlayBtn.classList.add('paused')
      }
    },
    // swiper activeIndex 설정
    setActiveIndex () {
      this.$nextTick(() => {
        const swiperInstance = this.swiper.instance

        if (swiperInstance) {
          this.swiper.activeIndex = swiperInstance.realIndex + 1
        }
      })
    },
    // 현재 활성 스와이퍼의 bg 컬러 기준으로 컨트롤러 색상 설정
    setControlColor () {
      this.$nextTick(() => {
        const swiperInstance = this.swiper.instance

        if (swiperInstance) {
          const swiperContainer = this.$refs.mmpVisualSlide
          // const activeIdx = this.swiper.activeIndex
          const swiperControl = this.$refs.swiperControl

          // swiperContainer가 존재하는지 확인
          if (swiperContainer) {
            const activeSlide = swiperContainer.querySelector(`.swiper-slide-active`)

            if (activeSlide && swiperControl) {
              if (activeSlide.classList.contains('light_bg')) {
                // 컨트롤러 배경색상 어둡게
                swiperControl.classList.add('dark_bg')
              } else {
                // 컨트롤러 배경색상 밝게
                swiperControl.classList.remove('dark_bg')
              }
            }
          }
        }
      })
    },
    // slide duplicated 이미지 업데이트 오류 보정
    updateDuplicatedSlide () {
      this.$nextTick(() => {
        const dupSlide = document.querySelector('#mmpVisualSlide2 .swiper-slide-next')
        if (dupSlide) {
          const idx = dupSlide.getAttribute('data-swiper-slide-index')
          const thumbEl = dupSlide.querySelector('.thumb img')
          const img = this.isDesktop ? this.slideData[idx].imgPc : this.slideData[idx].imgMo
          thumbEl.src = img
        }
      })
    },
    goSlideLink () {
      const currentSlideIdx = this.swiper.activeIndex - 1
      this.goPotltLink(this.slideData[currentSlideIdx])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompMmpVisualSlide2.vue